import React from "react";
import { CalendarClock, Pencil, X } from "lucide-react";

const fmt = (eastern) => {
  if (!eastern) return "";
  const [date, time] = eastern.split("T");
  const d = new Date(`${date}T00:00:00`);
  return `${d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} ${time} ET`;
};

export function ScheduleForm({ form, setForm, editing, busy, onSubmit, onStopEditing }) {
  const set = (key) => (event) => setForm({ ...form, [key]: event.target.value });
  return (
    <div className="border-t pt-5 space-y-3" style={{ borderColor: "var(--border)" }} data-testid="signin-schedule-form">
      <div className="flex items-center gap-1.5" style={{ color: "var(--muted)" }}><CalendarClock size={12} className="shrink-0" /> <span className="field-label !mb-0">{editing ? "Edit scheduled change" : "Or schedule this look for later"}</span></div>
      <p className="text-xs" style={{ color: "var(--muted)" }}>
        Uses the colour and photo selected above. Times are US Eastern. Leave the end empty to keep it as the new everyday panel.
      </p>
      <div className="flex flex-wrap gap-3">
        <label className="block"><span className="text-[10px] uppercase tracking-[0.15em]" style={{ color: "var(--muted)" }}>Goes live (ET)</span>
          <input type="datetime-local" className="input-flat" value={form.starts_at} onChange={set("starts_at")} data-testid="signin-schedule-start" /></label>
        <label className="block"><span className="text-[10px] uppercase tracking-[0.15em]" style={{ color: "var(--muted)" }}>Ends (ET, optional)</span>
          <input type="datetime-local" className="input-flat" value={form.ends_at} onChange={set("ends_at")} data-testid="signin-schedule-end" /></label>
        <label className="block flex-1 min-w-[160px]"><span className="text-[10px] uppercase tracking-[0.15em]" style={{ color: "var(--muted)" }}>Label (optional)</span>
          <input className="input-flat" maxLength={80} placeholder="e.g. Winter" value={form.label} onChange={set("label")} data-testid="signin-schedule-label" /></label>
      </div>
      <div className="flex flex-wrap gap-2">
        <button type="button" className="btn-ghost" disabled={busy || !form.starts_at} onClick={onSubmit} data-testid="signin-schedule-submit">
          {editing ? "Update scheduled change" : "Schedule change"}
        </button>
        {editing && <button type="button" className="btn-ghost" onClick={onStopEditing} data-testid="signin-schedule-stop-editing">Stop editing</button>}
      </div>
    </div>
  );
}

export function ScheduleList({ schedules, colors, photos, busy, onEdit, onCancel }) {
  if (!schedules.length) return <p className="text-xs" style={{ color: "var(--muted)" }} data-testid="signin-schedule-empty">No scheduled changes.</p>;
  return (
    <div className="space-y-2" data-testid="signin-schedule-list">
      {schedules.map((s) => (
        <div key={s.id} className="border px-3 py-2 flex flex-wrap items-center gap-3 text-sm" style={{ borderColor: "var(--border)" }} data-testid={`signin-schedule-${s.id}`}>
          <span className="h-5 w-5 border" style={{ background: s.panel.color, borderColor: "var(--border)" }} />
          <div className="flex-1 min-w-[220px]">
            <div style={{ color: "var(--ink)" }}>
              {s.label && <b className="mr-1.5">{s.label}</b>}
              {colors.find((c) => c.key === s.color)?.label} · {s.photo === "none" ? "No photo" : s.photo === "upload" ? "Uploaded photo" : photos.find((p) => p.key === s.photo)?.label}
            </div>
            <div className="text-xs" style={{ color: "var(--muted)" }} data-testid={`signin-schedule-when-${s.id}`}>
              {fmt(s.starts_at_eastern)} {s.ends_at_eastern ? `→ ${fmt(s.ends_at_eastern)}` : "→ stays as everyday panel"} · by {s.created_by}
            </div>
          </div>
          <span className={`pill text-[9px] ${s.state === "live" ? "pill-success" : ""}`} data-testid={`signin-schedule-state-${s.id}`}>{s.state === "live" ? "Live now" : "Upcoming"}</span>
          {s.state === "upcoming" && (
            <div className="flex gap-1.5">
              <button type="button" className="btn-ghost !py-1 !px-2 text-xs flex items-center gap-1" disabled={busy} onClick={() => onEdit(s)} data-testid={`signin-schedule-edit-${s.id}`}><Pencil size={12} /> Edit</button>
              <button type="button" className="btn-ghost !py-1 !px-2 text-xs flex items-center gap-1" disabled={busy} onClick={() => onCancel(s)} data-testid={`signin-schedule-cancel-${s.id}`}><X size={12} /> Cancel</button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
